import { CurrentBroker } from './individualEnrollment.models';
import { WorkflowStep } from './WorkflowStep.model';

export enum WorkflowStates {
  COMPLETE = 'complete',
  IN_PROGRESS = 'in_progress',
  NOT_STARTED = 'not_started',
  SKIPPED = 'skipped',
}

export enum WorkflowType {
  bp_individual_enrollment = 'bp_individual_enrollment',
  individual = 'individual',
  shp_individual_quote = 'shp_individual_quote',
  bp_individual_quote = 'bp_individual_quote',
}

export class Workflow<T> {
  children!: Array<any>;
  current_step!: WorkflowStep;
  current_step_number!: number;
  data: any;
  id!: number;
  parent!: number;
  relations: any;
  schema: any;
  state!: WorkflowStates;
  steps!: Array<WorkflowStep>;
  type!: string;
  values!: T;
  web_session_id!: string;
  webuser_id!: number;
  created_at?: string;
  helpers!: {
    checkForValueInStepAndPatch: Function;
    checkIfStepTypeExists: Function;
    getStepNumberByStepType: Function;
  };
  current_broker?: CurrentBroker;
  client?: any;

  constructor(init?: Record<string, unknown>) {
    Object.assign(this, init);
  }
}
